import React from 'react';
import classNames from 'classnames';
import { w_header_options } from 'shared/product_tabs/tab_parts/data/SelectOptions';

const WRow = (props) => {
  const { row, row_index, header, first_row, bom_parameters } = props;

  const row_id = `row-bom-${row_index + 1}`;

  return (
    <tr
      className={classNames('row-bom', {
        'header-selected': header === row_index + 1,
        'firstdata-selected': first_row === row_index + 1,
      })}
      id={row_id}>
      <td
        className='identify-row'
        id={`identify-row-${row_index + 1}`}
        data-row={row_index + 1}>
        <span>{row_index + 1}</span>
        <div className='text-identify'> </div>
      </td>
      {row.map((cell, index) => {
        const id = `column_${row_index}_${index}`;
        const parameter = bom_parameters[index];
        const selected_option = w_header_options.find(
          (option) => option.value === parameter,
        );

        return (
          <td
            key={id}
            id={id}
            className={classNames(`column-${index}`, {
              'column-selected':
                header !== row_index + 1 &&
                first_row !== row_index + 1 &&
                selected_option.value !== '',
            })}>
            {cell}
          </td>
        );
      })}
    </tr>
  );
};

export default WRow;
